export const PageLoadingAction = {
    SHOW_REQUEST: 'PAGE_LOADING_SHOW_REQUEST',
    HIDDEN_REQUEST: 'PAGE_LOADING_HIDDEN_REQUEST',
};
